import { render } from "./MyTemplates.vue?vue&type=template&id=ac300a8c"
import script from "./MyTemplates.vue?vue&type=script&lang=ts"
export * from "./MyTemplates.vue?vue&type=script&lang=ts"
script.render = render

export default script